import { bool, shape, string } from 'prop-types';

export default shape({
  name: string.isRequired,
  _id: string.isRequired,
  subDomain: string.isRequired,
  teamSyncEnabled: bool,
  employeeSyncEnabled: bool,
  ftpSyncEnabled: bool,
});
